// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course_slider_module-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n  width: 100%; }\n  .course_slider_module-layout .slider-page {\n    width: 100%; }\n  .course_slider_module-layout .container-offer-card-page {\n    width: calc(100% - 20px) !important; }\n", ""]);
// Exports
module.exports = exports;
